import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { initialize } from 'redux-form'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { get } from 'lodash'

import { ParentalConsentForm } from 'containers/forms/parental-contest'
import { Header, NarrowContainer, Section, Title } from 'components/layout'
import { Button, AuthCodeInvalid } from 'components/misc'
import { meta } from 'helpers/decorators'
import { apiCodeLists, apiParentalConsent } from 'helpers/decorators/api'
import { initialValues } from 'models/parental-consent'
import appConfig from 'config'
import { PAYMENT_TYPES } from '../../../constants/enums'
import { FormattedMessage } from 'react-intl'
import { push } from 'connected-react-router'


const foLink = appConfig.foUrl || 'https://www.onlinerecordbook.org/fo/'

const enhance = compose(
  meta({
    title: 'Parental Consent'
  }),
  apiCodeLists(['titles'], { public: true }),
  apiParentalConsent(),
  connect( () => ({}), { initialize, push })
)
class ParentalConsent extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    parentalConsent: PropTypes.object.isRequired,
    onSendParentalConsent: PropTypes.func.isRequired,
    onGetParentalConsent: PropTypes.func.isRequired,
    alreadySubmitted: PropTypes.bool.isRequired,
    initialize: PropTypes.bool,
    isConsentGiven: PropTypes.bool,
    notValid: PropTypes.bool.isRequired,
    push: PropTypes.func
  }

  componentDidMount() {
    this.props.onGetParentalConsent().then(({ body } = {}) => {
      this.props.initialize('parentalConsentForm', initialValues(body))
    })
  }

  handleRedirect = (paymentType, authCode, orgId) => {

    if (paymentType === PAYMENT_TYPES.online.id) {
      window.location.replace(`${foLink}/mpg-init/${authCode}`)
    }

    if (paymentType === PAYMENT_TYPES.payPal.id) {
      window.location.replace(`${foLink}/paypal-init/${authCode}`)
    }

    if (paymentType === PAYMENT_TYPES.globalPayments.id) {
      window.location.replace(`${foLink}/gp-init/${orgId}/${authCode}`)
    }

    if (paymentType === PAYMENT_TYPES.globalPaymentsWebpay.id) {
      window.location.replace(`${foLink}/gp-wp-init/${authCode}`)
    }
  }

  render() {
    const {
      parentalConsent,
      onSendParentalConsent,
      alreadySubmitted,
      notValid,
      isExpired
    } = this.props


    const authCode = get(parentalConsent, 'data.onlinePaymentAuthorizationCode')
    const orgId = get(parentalConsent, 'data.award.organization.id')
    const paymentType = get(parentalConsent, 'data.awardPayment.originPaymentType.value')
    const isConsentDeliveryConfirmed = get(parentalConsent, 'data.award.isConsentDeliveryConfirmed')
    const isPaymentConfirmed = get(parentalConsent, 'data.award.isPaymentConfirmed')

    return (
      <div>
        <Header />
        <NarrowContainer>
          {(notValid || isExpired) && <AuthCodeInvalid />}
          <Section loading={parentalConsent.loading}>
            {isConsentDeliveryConfirmed &&
              <div style={{ padding: '20px 0' }}>
                <Title h2 intlKey="label.consent_already_given_login">
                  Consent was already given. Please login as your child.
                </Title>
                <a href={foLink}>
                  <Button secondary intlKey="button.proceed_to_login">
                    Proceed to Login
                  </Button>
                </a>
                <br />
                {!isPaymentConfirmed && <div style={{ padding: '20px 0' }}>
                  <FormattedMessage id="label.follow_link_to_proceed_payment" defaultMessage="Follow the link to proceed to payment." />

                  <Button style={{ marginLeft: '10px' }}
                    intlKey='button.pay_now'
                    onClick={() => this.handleRedirect(paymentType, authCode, orgId)}
                  >
                    Pay Now
                  </Button>

                </div>}
              </div>}

            {!notValid && !isExpired &&
              !isConsentDeliveryConfirmed &&
              <ParentalConsentForm
                key={get(parentalConsent, 'data.organizationId')}
                codeLists={this.props.codeLists}
                onSubmit={onSendParentalConsent}
                data={parentalConsent.data}
                loading={parentalConsent.loading}
                alreadySubmitted={alreadySubmitted}
              />}
          </Section>
        </NarrowContainer>
      </div>
    )
  }
}

export default enhance(ParentalConsent)
